import { getAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { mappingTMBAnalytics } from "services/util/dataLayerAnalytics";
import { mockTmbHolabarcelona, mockTmbNightBus } from "./TmbDetailActivity.mocks";
declare const window: any;

export function getDetailTmbNigth(
	logged: boolean,
	id: any,
	callback: Function,
	callbackError: Function,
	lenguage: any,
	time:string,
	mock?: any,
) {
	//   const mockData = mockTmbHolabarcelona() as any;
	//   try {
	//     sessionStorage.setItem("raas-trip-mock-data", JSON.stringify(mockData));
	//   } catch (error) {
	//     sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
	//   }
	//   let filter=mockData.data['catalogue-items'].map((item: any,index:any) => ({
	//     ...item,
	//     id:index,
	//     isActive:index===0 ?true:false}

	//     ))
	//   console.log("filter",filter)
	//   callback(filter);

	if (mock === "true") {
		const mockData = mockTmbNightBus() as any;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		let filter = mockData.data["catalogue-items"].map(
			(item: any, index: any) => ({
				...item,
				id: index,
				isActive: index === 0 ? true : false,
			}),
		);
		callback(filter);
	} else {
        // V1
		// const apiWithParams = `/catalogues/${id}?language=${lenguage}`;
        // V2
		const apiWithParams = `/catalogues/v2/${id}?language=${lenguage}&serviceDate=${time}`;		
		getAxios(apiNames.TRVLMANAG, false, apiWithParams)
			.then((data: any) => {
				let activitiesCatalog = data.data["catalogue-items"].map(
					(item: any, index: any) => ({
						...item,
						catalogueItemId:item.id,
						id: index,
						isActive: index === 0 ? true : false,
					}),
				);
				let { result,typeCard} = mappingTMBAnalytics(window.sessionStorage["raas-id-tmb-select"]);
				window.dataLayer?.push({
					event: "select_content",
					screen_name: result,
					screen_class: 'TMB_schedule',
					content_name:typeCard+"1",
					content_type: 'button',
					option_selected:activitiesCatalog[0]?.name
				  });
				callback(activitiesCatalog);
			})
			.catch((error: any) => {
				callbackError(error);
			});
	}
}
export function getDetailTmb(
	logged: boolean,
	id: any,
	callback: Function,
	callbackError: Function,
	lenguage: any,
	time:string,
	mock?: any,
) {
	//   const mockData = mockTmbHolabarcelona() as any;
	//   try {
	//     sessionStorage.setItem("raas-trip-mock-data", JSON.stringify(mockData));
	//   } catch (error) {
	//     sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
	//   }
	//   let filter=mockData.data['catalogue-items'].map((item: any,index:any) => ({
	//     ...item,
	//     id:index,
	//     isActive:index===0 ?true:false}

	//     ))
	//   console.log("filter",filter)
	//   callback(filter);

	if (mock === "true") {
		const mockData = mockTmbNightBus() as any;
		try {
			sessionStorage.setItem(
				"raas-trip-mock-data",
				JSON.stringify(mockData),
			);
		} catch (error) {
			sessionStorage.setItem("raas-trip-mock-data", "error saving mock");
		}
		let filter = mockData.data["catalogue-items"].map(
			(item: any, index: any) => ({
				...item,
				id: index,
				isActive: index === 0 ? true : false,
			}),
		);
		callback(filter);
	} else {
        // V1
		// const apiWithParams = `/catalogues/${id}?language=${lenguage}`;
        // V2
		const apiWithParams = `/catalogues/v2/${id}?language=${lenguage}`;		
		getAxios(apiNames.TRVLMANAG, false, apiWithParams)
			.then((data: any) => {
				let activitiesCatalog = data.data["catalogue-items"].map(
					(item: any, index: any) => ({
						...item,
						catalogueItemId:item.id,
						id: index,
						isActive: index === 0 ? true : false,
					}),
				);
				let { result,typeCard} = mappingTMBAnalytics(window.sessionStorage["raas-id-tmb-select"]);
				window.dataLayer?.push({
					event: "select_content",
					screen_name: result,
					screen_class: 'TMB_schedule',
					content_name:typeCard+"1",
					content_type: 'button',
					option_selected:activitiesCatalog[0]?.name
				  });
				callback(activitiesCatalog);
			})
			.catch((error: any) => {
				callbackError(error);
			});
	}
}

/**
 * Funcion que obtiene y mapea el idioma para TMB
 * @returns Devuelve idioma mostrado en web
 */
export function getLanguageTMB(lenguage?: any) {
	let result = "";

	switch (lenguage) {
		case "ca":
			result = "ca-ES";
			break;
		/*case "gl":
      result = "ca-ES";
      break;*/
		case "eu":
			result = "eu-ES";
			break;
		case "en":
			result = "en-GB";
			break;
		case "fr":
			result = "fr-FR";
			break;
		/*case "va":
      result = "fr-FR";
      break;*/
		default:
			result = "es-ES";
			break;
	}

	return result;
}
